import { FormInstance } from "antd";
import { createContext } from "react";

import { DragIndexState } from "./type";

export const EditableContext = createContext<FormInstance<unknown> | null>(null);
export const DragIndexContext = createContext<DragIndexState>({ active: -1, over: -1 });
